module.exports = __webpack_public_path__ + "assets/img/1.293e68ca.png";